import { readNestedBookingRecord } from './nestedBookingRecord';

export function parseGuestBookingsValue(value: unknown): number | undefined {
  if (typeof value === 'number' && Number.isFinite(value) && value >= 0) {
    return value;
  }
  if (typeof value === 'string') {
    const parsed = Number(value.trim());
    if (Number.isFinite(parsed) && parsed >= 0) {
      return parsed;
    }
  }
  return undefined;
}

/** Nested `Booking` guest count first, then top-level — matches hydrate / spot-bookings parsing. */
export function readGuestBookingsFromRecord(source: Record<string, unknown>): number | undefined {
  const nested = readNestedBookingRecord(source);
  if (nested) {
    const nestedValue = nested['guest_bookings'] ?? nested['guestBookings'];
    if (nestedValue != null) {
      const nestedParsed = parseGuestBookingsValue(nestedValue);
      if (nestedParsed !== undefined) {
        return nestedParsed;
      }
    }
  }
  return parseGuestBookingsValue(source['guest_bookings'] ?? source['guestBookings']);
}

/** Minimal payload for guest-only list-row merges (nested `Booking` first, then top-level). */
export function buildGuestBookingsMergePayload(
  source: Record<string, unknown>
): Record<string, unknown> {
  const nested = readNestedBookingRecord(source);
  if (nested) {
    const nestedValue = nested['guest_bookings'] ?? nested['guestBookings'];
    if (nestedValue != null) {
      const nestedParsed = parseGuestBookingsValue(nestedValue);
      if (nestedParsed !== undefined) {
        const nestedGuest: Record<string, unknown> = {};
        if ('guest_bookings' in nested) {
          nestedGuest['guest_bookings'] = nested['guest_bookings'];
        }
        if ('guestBookings' in nested) {
          nestedGuest['guestBookings'] = nested['guestBookings'];
        }
        if (Object.keys(nestedGuest).length > 0) {
          return { Booking: nestedGuest };
        }
      }
    }
  }

  const topLevel: Record<string, unknown> = {};
  if ('guest_bookings' in source) {
    topLevel['guest_bookings'] = source['guest_bookings'];
  }
  if ('guestBookings' in source) {
    topLevel['guestBookings'] = source['guestBookings'];
  }
  return topLevel;
}
